import type {
  ArchiveCampaignCallback,
  CreateCampaignCallbacks,
  DuplicateCampaignCallback,
} from '@/components/shared/types'
import type { OrderItem } from '@/flight-deck-api/services/order-items.service'
import type { ViewMode } from '../dashboard'
import { OrderItemGrid } from './order-item-grid'
import { OrderItemList } from './order-item-list'

type Props = {
  orderItems: OrderItem[]
  isLoading?: boolean
  onDuplicateCampaign: DuplicateCampaignCallback
  onArchiveCampaign: ArchiveCampaignCallback
  isFetching: boolean
  currentPage: number
  pageSize: number
  lastItemRef: (node: HTMLDivElement | null) => void
  expandedRows: Set<number>
  toggleRow: (orderItemId: number) => void
  view: ViewMode
} & CreateCampaignCallbacks

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const OrderItemDisplay: React.FC<Props> = props => {
  const { view, ...rest } = props
  return <div className="w-full">{view === 'list' ? <OrderItemList {...rest} /> : <OrderItemGrid {...rest} />}</div>
}
